import React, { useEffect } from "react";
import Filter from "./Filter";
import Image from "./Image";
import Loader from "./Loader";

export default function ImgContainer({
  onFilterClick,
  filterImages,
  filters,
  removeItemFromFilter,
  images,
  showFullSize,
}) {
  useEffect(() => {
    const header = document.getElementById("myHeader");
    const rect = header.getBoundingClientRect();
    const sticky = rect.top;

    const scrollCallBack = window.addEventListener("scroll", () => {
      if (window.pageYOffset > sticky) {
        header.classList.add("sticky");
      } else {
        header.classList.remove("sticky");
      }
    });
    return () => {
      window.removeEventListener("scroll", scrollCallBack);
    };
  }, []);

  return (
    <div className="container">
      <div className="row">
        <div className="col-12 filterheader">
          <h4 className="ml3 mt4">Finn din flaskeb&aelig;rem&aring;te</h4>
        </div>
      </div>
      <div className="row">
        <div className="col-12" id="myHeader">
          <Filter
            onFilterClick={onFilterClick}
            filters={filters}
            removeItemFromFilter={removeItemFromFilter}
          />
        </div>
      </div>{" "}
      <div className="row">
        {filterImages.map(function (item) {
          return (
            <Image
              title={item.title}
              description={item.description}
              img={item.img}
              key={item.id}
              id={item.id}
              showFullSize={showFullSize}
            />
          );
        })}

        {filterImages.length === 0 && <>Fant ingen bilder!</>}
      </div>
    </div>
  );
}
